<template>
  <div class="pendings" v-if="!!listTRegisters.length">
    <md-progress-bar md-mode="indeterminate" v-if="loading" />
    <div class="pendings__filtros">
      <!-- <md-field> -->
      <!-- <md-select
        v-model="status" @md-selected="selectFilter">
        <md-option value="pendxcomp">Todos</md-option>
        <md-option value="complete">Completados</md-option>
        <md-option value="pending">Por completar</md-option>
      </md-select>-->
      <!-- </md-field> -->
      <md-checkbox v-model="allChecked">Todos</md-checkbox>
    </div>
    <div
      class="pendings__filtros pendings__filtros--start"
    >Eliga los T-Registros, dando click al signo de exclamación en ellos.</div>

    <div class="pendings__head">
      <div class="pendings__head-names">Apellidos y Nombres</div>
      <div class="pendings__head-dni">Documento</div>
      <div class="pendings__head-state">Estado</div>
    </div>

    <div class="pendings__body">
      <template v-if="loading">
        <template v-if="!isLarge">
          <div class="item-loading" v-for="n in 15" :key="n">
            <vue-content-loading :width="120" :height="40" primary="#f3f3f3" secondary="#e0e0e0">
              <circle cx="12" cy="12" r="7.5" />
              <rect x="25" y="5" rx="3" ry="3" width="80" height="5" />
              <rect x="25" y="12.5" rx="3" ry="3" width="80" height="15" />
            </vue-content-loading>
          </div>
        </template>
        <template v-else>
          <div class="item-loading" v-for="n in 15" :key="n">
            <vue-content-loading :width="600" :height="40" primary="#f3f3f3" secondary="#e0e0e0">
              <circle cx="25" cy="20" r="13" />
              <rect x="60" y="12.5" rx="3" ry="3" width="175" height="15" />
              <rect x="275" y="12.5" rx="3" ry="3" width="80" height="15" />
              <rect x="390" y="10" rx="3" ry="3" width="100" height="20" />
            </vue-content-loading>
          </div>
        </template>
      </template>

      <template v-else>
        <TRow
          v-for="(item) in listTRegisters"
          :key="item.id"
          :data="item"
          @setCurrentTRegister="setCurrentTRegisterItem(item)"
          @deleteTRegister="deleteTR"
          noTareo
          :allchecked="allChecked"
          @check="checkList($event)"
        />
      </template>
    </div>

    <md-button
      v-show="listTRegisters.length>0"
      class="md-raised generateEmployee"
      @click="createEmp=true"
    >Generar empleado</md-button>

    <paginate
      v-model="page"
      :pageCount="pages"
      :prev-text="'p'"
      :next-text="'q'"
      :containerClass="'pagination'"
      :page-class="'page-item'"
      :clickHandler="clickCallback"
    ></paginate>

    <TRegister
      v-if="showTRegister"
      :newUser="false"
      :currentData="currentTRegister"
      @close-modal="closeTregister"
      :origin="status"
      :details="details"
    />

    <md-dialog-confirm
      v-if="showDeleteTR"
      :md-active.sync="showDeleteTR"
      :md-click-outside-to-close="false"
      md-title="¿Está usted seguro de eliminar este T-Registro?"
      :md-content="`Eliminará el T-Registro de <strong>${String(currentTRegister.firstName).split(' ')[0]} ${String(currentTRegister.firstSurname)}.</strong><br>Esta opción no podrá deshacerse.`"
      md-confirm-text="Aceptar"
      md-cancel-text="Cancelar"
      @md-cancel="onDeleteCancel"
      @md-confirm="onDeleteConfirm"
    />

    <md-dialog-confirm
      v-if="createEmp"
      :md-active.sync="createEmp"
      :md-click-outside-to-close="false"
      md-title="¿Activar el Tareo para los TRegistros?"
      :md-content="`Se activarán los Tareos de <strong>${checkedTR.length}</strong> TRegistros.`"
      md-confirm-text="Confirmar"
      md-cancel-text="Cancelar"
      @md-confirm="generateEmployeeConfirm"
    />
  </div>
  <div class="nodata-content" v-else>
    <img src="../../assets/img/no_data.svg" alt />
    <h5>No hay datos disponibles</h5>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import EventBus from "@/eventBus";

import TRow from "@/components/TRegisters/TRow";
import Paginate from "vuejs-paginate";

export default {
  name: "ForEmployee",
  components: {
    TRow,
    Paginate,
    TRegister: () => import("@/components/TRegister"),
    VueContentLoading: () => import("vue-content-loading")
  },
  created() {
    this.$emit("loading-status", true)
    this.getTRegisters({
      id: this.$localStorage.get("businessID"),
      state: "foremployee",
      page: 1
    }).then(r => {
      if (r.status == 200) {
        this.loading = false;
        this.pages = r.data.totalPages;
        this.$emit("loading-status", false)
        EventBus.$emit("stateView", "foremployee");
      }
    });

    this.listTRegisters = this.listado;
  },
  mounted() {
    console.log(this.listTRegisters);
    EventBus.$on("newTR", () => {
      this.status = "foremployee";
    });
    EventBus.$on("pageDefault", () => {
      this.page = 1;
    });
    EventBus.$on("totalPages", r => {
      console.log(r);
      this.pages = r;
    });
  },
  data() {
    return {
      listTRegisters: null,
      status: "foremployee",
      currentTRegister: null,
      showTRegister: false,
      showDeleteTR: false,
      createEmp: false,
      loading: true,
      details: null,
      checkedTR: [],
      allChecked: false,
      pages: 1,
      page: 1
    };
  },
  watch: {
    listado(newValue, oldValue) {
      this.listTRegisters = newValue;
      // this.status = "pendxcomp"
    },
    allChecked(newValue, oldValue) {
      if (newValue) {
        this.checkedTR = this.TRComplete.map(o => o.id);
      } else {
        this.checkedTR = [];
      }
    }
  },
  computed: {
    ...mapGetters({
      listado: "listForEmployeeTRegister"
    }),
    isLarge() {
      if (window.innerWidth < 1200) return false;
      else return true;
    },

    TRComplete() {
      return this.listTRegisters.filter(o => o.state == "foremployee");
    }
  },
  methods: {
    ...mapActions({
      deleteTRegister: "deleteTRegister",
      getTRegisters: "getTRegisters",
      createEmployee: "createEmployee",
      getTRegister: "getTRegister",
    }),
    closeTregister() {
      console.log("aqui debe cerrar el modal del tregistro");
      this.showTRegister = false;
    },
    async setCurrentTRegisterItem(item) {
      this.currentTRegister = item;
      let {data, status} = await this.getTRegister(item.id)
      console.log(data, status)
      if(status == 200){
        console.log("populando details")
        this.details = data
        this.showTRegister = true;
      }
    },
    deleteTR(item) {
      this.currentTRegister = item;
      this.showDeleteTR = true;
    },
    onDeleteCancel() {
      console.log("Canceló");
      this.currentTRegister = null;
    },
    onDeleteConfirm() {
      console.log("Aceptó");
      this.deleteTRegister(this.currentTRegister.id).then(r => {
        if (r.status == 200) {
          console.log("TRegistro eliminado");
          this.currentTRegister = null;
          // this.getTRegisters(this.$localStorage.get('businessID')).then(r => {
          //   if(r.status == 200)
          //     console.log('lista de tregistros actualizados')
          // })

          this.getTRegisters({
            id: this.$localStorage.get("businessID"),
            state: "foremployee",
            page: 1
          }).then(r => {
            if (r.status == 200) {
              this.pages = r.data.totalPages;
              this.page = 1;
              console.log("lista tregistros actualizados");
            }
          });
        }
      });
    },

    selectFilter(value) {
      this.getTRegisters({
        id: this.$localStorage.get("businessID"),
        state: value,
        page: 1
      }).then(r => {
        if (r.status == 200) {
          this.pages = r.data.totalPages;
          this.page = 1;
        }
      });
    },
    checkList($event) {
      if ($event.flag) {
        this.checkedTR.push($event.id);
      } else {
        this.checkedTR = this.checkedTR.filter(i => i != $event.id);
      }
    },
    generateEmployeeConfirm() {
      if (!!this.checkedTR.length) {
        this.generateEmployee(this.checkedTR);
      } else {
        this.$toasted.show("No hay T-Registros seleccionados", {
          theme: "bubble",
          position: "top-right",
          duration: 5000,
          className: "short-message"
        });
      }
    },
    generateEmployee(emp) {
      // let emp = this.TRComplete.map(o => o.id)

      console.log(emp);

      this.createEmployee({
        list: emp
      }).then(r => {
        if (r.status == 200) {
          console.log("empleados creados", r);
          this.getTRegisters({
            id: this.$localStorage.get("businessID"),
            state: "foremployee",
            page: 1
          }).then(r => {
            console.log(r);

            this.pages = r.data.totalPages;
            this.page = 1;
          });
        }
      });
    },

    //para el paginado
    clickCallback: function(page) {
      console.log(page);
      this.getTRegisters({
        id: this.$localStorage.get("businessID"),
        state: this.status,
        page: page
      });
    }
  }
};
</script>

<style lang="scss">
.pagination {
  display: flex;
  justify-content: flex-end;
  li:nth-child(1) {
    font-family: "bluebox";
    font-size: 1.5rem;
    width: 2rem;
    height: 2rem;
    border-radius: 0.3rem;
    border: 1px solid #e8e9ec;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 0.1rem;
    a {
      color: #808495;
      text-decoration: none;
    }
  }
  li:nth-last-child(1) {
    font-family: "bluebox";
    font-size: 1.5rem;
    width: 2rem;
    height: 2rem;
    border-radius: 0.3rem;
    border: 1px solid #e8e9ec;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 0.1rem;
    a {
      color: #808495;
      text-decoration: none;
    }
  }
}

// .page-item {
//   width: 2rem;
//   height: 2rem;
//   border-radius: 0.3rem;
//   border: 1px solid #e8e9ec;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   margin: 0 0.1rem;
//   transition: all 0.3 ease-in-out;
//   background-color: white;
//   a {
//     color: #4d4f5c !important;
//   }
//   &.active {
//     border: 1px solid #3b86ff;
//     background-color: #3b86ff;
//     a {
//       color: white !important;
//     }
//   }
// }
</style>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #C63832;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: "../assets/img/";

//2-TOOLS
//functions
//background-image function
@function bimg($img) {
  @return url($p-img+$img);
}
//mixins
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}

//7-TRUMPS
//vue-material
.md-field {
  width: 15rem;
  // margin: 0 3rem 2rem 3rem;
  @include mq($sm) {
    width: 21rem;
  }

  &.md-theme-default {
    label {
      color: rgba($b-blue, 0.6);
      &::after {
        color: $b-orange;
      }
    }
    &::after {
      background-color: #d7dae2;
    }
    &::before {
      background-color: $b-blue;
    }
    &.md-focused {
      label {
        color: $b-blue-dark;
      }
    }

    &.md-invalid {
      label {
        color: $b-orange;
      }
      &::after {
        background-color: $b-orange;
      }
      .md-error {
        color: $b-orange;
      }
    }
  }
}

.md-dialog {
  z-index: 900;
}

.generateEmployee {
  background-color: #d8ff00 !important;
  color: white !important;
  padding: 0.3rem;
  margin-left: 0;
  // pointer-events: none;
}
.cargaMasiva {
  background-color: $b-blue !important;
  color: white !important;
  padding: 0.3rem;
  margin-left: 0;
  // pointer-events: none;
}

.pendings {
  &__filtros {
    display: flex;
    justify-content: center;
    @include mq($lg) {
      justify-content: flex-end;
    }
    &--start {
      justify-content: flex-start;
      margin-bottom: 2rem;
    }
  }
  &__head {
    display: none;
    @include mq($lg) {
      display: flex;
      margin-left: calc(9px + 5.3rem);
      width: 89%;
      font-weight: 600;
      font-size: 1.1rem;
      margin-bottom: 1.5rem;
      &-names {
        width: 42%;
      }
      &-dni {
        width: 21%;
      }
    }
  }
  &__body {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
}

.item-loading {
  width: 24rem;
  height: 8rem;
  border-radius: 9px;
  margin: 1rem auto;
  @include mq($lg) {
    width: 100%;
    height: 4rem;
    margin: 0.5rem 0;
  }
}

.ptmr {
  fill: red;
}

.nodata-content {
  padding: 2rem;
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  img {
    width: 300px;
    margin: 0 auto;
  }
  h5 {
    color: $b-emph;
    margin: 2rem auto;
    font-size: 24px;
  }
}
</style>
